export default "__VITE_ASSET__3242cb8e__"